import { IFranchiseeId } from '../types';

export const initialState: IFranchiseeId = { franchiseeId: '' };
